var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneric11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 99,
    viewBox: "0 0 100 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5747_5110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5747_5110)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5747_5110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5747_5110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 80.0027,
    height: 80.0027,
    rx: 40.0013,
    fill: "#CCCEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.223,
    y: 46.8904,
    width: 25.3342,
    height: 6.44466,
    rx: 3.22233,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.666689
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5747_5110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.7795,
    y: 72.305,
    width: 48.2238,
    height: 51.1128,
    rx: 24.1119,
    transform: "rotate(-16 19.7795 72.305)",
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.666689
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7789,
    y: 59.1129,
    width: 13.556,
    height: 6.44466,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.666689
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.1123,
    y: 58.7795,
    width: 12.8893,
    height: 8.88919,
    fill: "#FFD64C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.6676,
    y: 30.0007,
    width: 20.4451,
    height: 32.2233,
    rx: 10.2226,
    fill: "#FFD64C",
    stroke: "#111111",
    strokeWidth: 0.666689
  })), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-1_5747_5110",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7495 67.4464C61.3125 70.9053 56.1699 73.6353 49.8903 73.6353C43.647 73.6353 38.5277 70.9369 38.0391 67.5065C29.6765 69.9016 23.5562 77.6042 23.5562 86.7364V101.848H76.4468V86.7364C76.4468 77.5264 70.2216 69.7704 61.7495 67.4464Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7495 67.4464C61.3125 70.9053 56.1699 73.6353 49.8903 73.6353C43.647 73.6353 38.5277 70.9369 38.0391 67.5065C29.6765 69.9016 23.5562 77.6042 23.5562 86.7364V101.848H76.4468V86.7364C76.4468 77.5264 70.2216 69.7704 61.7495 67.4464Z",
    fill: "#F0F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7495 67.4465L61.9258 66.8035L61.1844 66.6002L61.088 67.3629L61.7495 67.4465ZM38.0391 67.5066L38.6992 67.4126L38.5913 66.6549L37.8556 66.8656L38.0391 67.5066ZM23.5562 101.848H22.8895V102.515H23.5562V101.848ZM76.4468 101.848V102.515H77.1135V101.848H76.4468ZM61.088 67.3629C60.9088 68.7814 59.7369 70.1797 57.7011 71.2476C55.6865 72.3044 52.9406 72.9687 49.8903 72.9687V74.302C53.1196 74.302 56.0847 73.6013 58.3206 72.4284C60.5352 71.2666 62.1531 69.5704 62.4109 67.53L61.088 67.3629ZM49.8903 72.9687C46.8577 72.9687 44.1258 72.3122 42.1144 71.2659C40.0819 70.2087 38.8999 68.822 38.6992 67.4126L37.3791 67.6006C37.667 69.6215 39.289 71.2992 41.4991 72.4488C43.7302 73.6093 46.6796 74.302 49.8903 74.302V72.9687ZM24.2228 86.7364C24.2228 77.9097 30.1385 70.4628 38.2227 68.1475L37.8556 66.8656C29.2146 69.3404 22.8895 77.2989 22.8895 86.7364H24.2228ZM24.2228 101.848V86.7364H22.8895V101.848H24.2228ZM76.4468 101.181H23.5562V102.515H76.4468V101.181ZM75.7801 86.7364V101.848H77.1135V86.7364H75.7801ZM61.5731 68.0894C69.7632 70.336 75.7801 77.8344 75.7801 86.7364H77.1135C77.1135 77.2185 70.6801 69.2049 61.9258 66.8035L61.5731 68.0894Z",
    fill: "#111111",
    mask: "url(#path-10-inside-1_5747_5110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.037 40.5107C62.037 31.9215 57.2987 26.1118 51.5271 26.1118C44.1331 26.1118 36.5996 28.8854 36.5996 42.0005C36.5996 45.2455 36.8413 47.6637 38.7785 49.4459C39.0007 49.6504 39.5714 50.0961 39.4675 49.9171C39.0918 46.4106 41.813 44.6342 45.8899 42.0005C48.0541 40.6024 52.5567 38.0011 54.2235 36.6677C55.4704 37.3743 57.9709 39.3823 58.6692 40.5794C59.0437 41.2214 59.6451 43.4215 60.056 45.9898C61.3996 44.376 62.037 42.7611 62.037 40.5107Z",
    fill: "#111111",
    stroke: "#111111",
    strokeWidth: 0.853796
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1392 35.6312C54.8513 34.0789 57.4127 30.5359 57.2483 28.2347",
    stroke: "#111111",
    strokeWidth: 0.853796
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 5.75,
    width: 78.5027,
    height: 78.5027,
    rx: 39.2513,
    stroke: "white",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 6.5,
    width: 77,
    height: 77,
    rx: 38.5,
    stroke: "white",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5747_5110",
    x: 0.909091,
    y: 0.454545,
    width: 98.1818,
    height: 98.1818,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.54545
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.54545
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0 0.0666667 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5747_5110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5747_5110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5747_5110",
    x: -10,
    y: -5,
    width: 120.003,
    height: 120.003,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.113725 0 0 0 0 0.156863 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5747_5110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5747_5110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5747_5110"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5747_5110"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 80.0027,
    height: 80.0027,
    rx: 40.0013,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5747_5110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.8905,
    height: 71.1135,
    fill: "white",
    transform: "translate(25.5562 10.3335)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneric11);
export default __webpack_public_path__ + "static/media/Generic 11.9470be1f078d1f4fecefe959b3aeccd9.svg";
export { ForwardRef as ReactComponent };